// Generate a unique identifier for the tab
if (!sessionStorage.getItem("tabId")) {
    sessionStorage.setItem("tabId", `tab-${Date.now()}`);
}
const tabId = sessionStorage.getItem("tabId");

// Utility functions to manage dialog queue in localStorage
function getDialogQueue() {
    const allQueues = JSON.parse(localStorage.getItem("dialogQueue")) || {};
    return allQueues[tabId] || [];
}

function setDialogQueue(queue) {
    const allQueues = JSON.parse(localStorage.getItem("dialogQueue")) || {};
    allQueues[tabId] = queue;
    localStorage.setItem("dialogQueue", JSON.stringify(allQueues));
}

function enqueueDialog(dialogKey, labResponse) {
    const queue = getDialogQueue();
    queue.push({ dialogKey, labResponse });
    setDialogQueue(queue);
}

function dequeueDialog() {
    const queue = getDialogQueue();
    const nextDialog = queue.shift();
    setDialogQueue(queue);
    return nextDialog;
}

function getNextDialog() {
    const queue = getDialogQueue();

    // get the 1st item in the dialogQueue
    if (queue.length > 0) {
        return queue[0];
    } else {
        return null;
    }
}

export default {
    getDialogQueue,
    enqueueDialog,
    dequeueDialog,
    getNextDialog
};
